import { Reveal, Overline } from "@/components/Reveal";

const occasions = [
  {
    title: "Corporate Events",
    desc: "Branded favors & bulk gifting for clients, teams, milestones and festive drives.",
    img: "https://customer-assets-jai6qajn.emergentagent.net/job_elixz-occasions/artifacts/vu524uin_WhatsApp%20Image%202026-07-25%20at%202.59.09%20PM%20%282%29.jpeg",
  },
  {
    title: "Weddings & Appreciation",
    desc: "Rose bouquets & keepsake gifts that guests and loved ones remember.",
    img: "https://customer-assets-jai6qajn.emergentagent.net/job_elixz-occasions/artifacts/gyq68ij0_WhatsApp%20Image%202026-07-25%20at%202.59.08%20PM.jpeg",
  },
  {
    title: "Birthdays & Baby Showers",
    desc: "Balloon bouquets, boxes and platters styled for the happiest milestones.",
    img: "https://customer-assets-jai6qajn.emergentagent.net/job_elixz-occasions/artifacts/5lg310su_WhatsApp%20Image%202026-07-25%20at%203.02.25%20PM.jpeg",
  },
];

export default function Occasions() {
  return (
    <section
      id="occasions"
      className="relative bg-[#140823] py-24 md:py-32"
      data-testid="occasions"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="text-center">
          <Reveal>
            <Overline>Gifting for every moment</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mx-auto mt-5 max-w-3xl font-serif text-4xl font-light leading-tight md:text-6xl">
              One brand, endless{" "}
              <span className="gold-gradient-text italic">occasions</span>.
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-10 md:grid-cols-3">
          {occasions.map((o, i) => (
            <Reveal key={o.title} delay={i * 0.12} className="group text-center">
              <div className="mx-auto overflow-hidden rounded-t-[999px] border border-[#311B4D]">
                <img
                  src={o.img}
                  alt={o.title}
                  className="h-[420px] w-full object-cover transition-transform duration-[900ms] group-hover:scale-105"
                />
              </div>
              <h3 className="mt-7 font-serif text-2xl text-[#FDFBF7] md:text-3xl">
                {o.title}
              </h3>
              <p className="mx-auto mt-3 max-w-xs text-sm leading-relaxed text-[#A894C2]">
                {o.desc}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
